// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"25":"4a94fcff","168":"8c67dd72","173":"a7fa1d0e","327":"005eec81","441":"38b9b60a","470":"04c98ae0","561":"a3d26619","815":"d9c614a7","915":"2109c5e1"}[chunkId] + ".chunk.css";
};